export const appSeoTranslationKeysByPath = {
  '/': 'home',
  '/features': 'features',
  '/pricing': 'pricing',
  '/about': 'about',
  '/contact': 'contact',
  '/privacy': 'privacy',
  '/terms': 'terms',
  '/offline': 'offline',
} as const;

export const landingPageTranslationKeysByPath = {
  '/lead-management-system': 'leadManagementSystem',
  '/lead-crm': 'leadCrm',
  '/crm-for-sales-team': 'crmForSalesTeam',
  '/sales-lead-tracking-software': 'salesLeadTrackingSoftware',
  '/crm-with-whatsapp-integration': 'crmWithWhatsAppIntegration',
  '/sales-automation-software': 'salesAutomationSoftware',
  '/best-crm-for-small-business': 'bestCrmForSmallBusiness',
  '/lead-follow-up-software': 'leadFollowUpSoftware',
  '/zoho-crm-alternative': 'zohoCrmAlternative',
  '/hubspot-alternative': 'hubspotAlternative',
  '/leadsquared-alternative': 'leadsquaredAlternative',
  '/online-lead-management-software': 'onlineLeadManagementSoftware',
  '/crm-with-role-based-access': 'crmWithRoleBasedAccess',
  '/whatsapp-crm-for-small-business': 'whatsappCrmForSmallBusiness',
  '/sales-dashboard-software': 'salesDashboardSoftware',
} as const;
